import { useState } from "react";
import TopupWalletPopup from "./TopupWalletPopup";

const TopupWallet = ({ getTransactions }) => {
  const [busy, setBusy] = useState(false);

  return (
    <>
      <button
        onClick={() => {
          setBusy(true);
        }}
        className="btn btn-success btn-md w-100 w-md-auto mb-2"
        disabled={busy === true ? true : false}
      >
        {busy === true ? (
          <span
            className="spinner-border spinner-border-xs"
            role="status"
            aria-hidden="true"
          ></span>
        ) : (
          <>
            <i className="ri-wallet-line me-1 fw-medium align-middle"></i>
            Topup
          </>
        )}
      </button>
      <TopupWalletPopup
        busy={busy}
        setBusy={setBusy}
        getTransactions={getTransactions}
      />
    </>
  );
};

export default TopupWallet;
